<app-pageheader [Parent]="this">
  <add-button AddRoute="/parking/parking/spacetypes/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="infrastructure/spacetypes/searches"
  [AllowEdit]="true" EditUrl="/parking/parking/spacetypes/:id/edit">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>